import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  //tabla principal de los header de agrotrack
  Table.tableColumns = [
    {
      prop: 'header_date',
      label: i18n.t('common_words.date'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'worker.code',
      label: 'Código Trabajador',
      sortable: true,
      minWidth: 100,
      align: 'center',
    },
    {
      prop: 'worker.name',
      label: i18n.t('labor.worker'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
    },
  ];
  //tabla secundaria de detalles del header seleccionado de agrotrack
  const TableDetails = { ...Tables.Table };
 //columnas de los detalles del header seleccionado de agrotrack
  TableDetails.tableColumns = [
    {
      prop: 'detail_date',
      label: i18n.t('common_words.date'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'activity.code',
      label: 'Código Actividad',
      minWidth: 100,
      align: 'center',
      sortable: true,
    },
    {
      prop: 'activity.name',
      label: i18n.t('common_words.activity'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'lot.name',
      label: i18n.t('common_words.allotment'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'total_duration',
      label: 'Duración de actividad',
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
  ];
  // Buscador, paginado y demas de la tabla de los detalles del header seleccionado de agrotrack
  const SearchDetails = {
    pagedDataDetails() {
      return this.tableDataDetails.slice(this.fromDetails, this.toDetails);
    },

    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedDataDetails() {
      let result = this.tableDataDetails;
      if (this.searchQueryDetails !== '') {
        result = this.fuseSearchDetails.search(
          '=' + this.searchQueryDetails + ''
        );
      }
      this.paginationDetails.total = result.length;

      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.totals = this.paginationDetails.total;
      }

      return result.slice(this.fromDetails, this.toDetails);
    },

    toDetails() {
      let highBound = this.fromDetails + this.paginationDetails.perPage;
      if (this.totalDetails < highBound) {
        highBound = this.totalDetails;
      }

      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.tos = highBound;
      }

      return highBound;
    },

    fromDetails() {
      let from =
        this.paginationDetails.perPage *
        (this.paginationDetails.currentPage - 1);
      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.froms = from;
      }

      return from;
    },

    totalDetails() {
      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.totals = this.paginationDetails.total;
      }

      return this.paginationDetails.total;
    },
  };
  //tabla principal de los header del track de la movil
  const TableDataMobileTracks = { ...Tables.Table };
  //columnas de la tabla principal de los header del track de la movil
  TableDataMobileTracks.tableColumns = [
    {
      prop: 'header_date_save',
      label: i18n.t('common_words.date'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'user.name',
      label: i18n.t('common_words.names'),
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'lot.name',
      label: i18n.t('common_words.allotment'),
      minWidth: 150,
      sortable: true,
      formatter: (row) => {
        return `${row.lot.name ? row.lot.name : ''}`;
      },
    },
  ];
  // Buscador, paginado y demas de la tabla principal de los header del track de la movil
  const SearchMobileTracks = {
    pagedDataMobileTracks() {
      return this.TableDataMobileTracks.slice(this.fromMobileTracks, this.toMobileTracks);
    },

    queriedDataMobileTracks() {
      let result = this.tableDataMobileTracks;
      if (this.searchQueryMobileTracks !== '') {
        result = this.fuseSearchMobileTracks.search(
          '=' + this.searchQueryMobileTracks + ''
        );
      }
      this.paginationMobileTracks.total = result.length;

      if (this.$refs.cardfootermobiletrack) {
        this.$refs.cardfootermobiletrack.totals = this.paginationMobileTracks.total;
      }

      return result.slice(this.fromMobileTracks, this.toMobileTracks);
    },

    toMobileTracks() {
      let highBound = this.fromMobileTracks + this.paginationMobileTracks.perPage;
      if (this.totalMobileTracks < highBound) {
        highBound = this.totalMobileTracks;
      }

      if (this.$refs.cardfootermobiletrack) {
        this.$refs.cardfootermobiletrack.tos = highBound;
      }

      return highBound;
    },

    fromMobileTracks() {
      let from =
        this.paginationMobileTracks.perPage *
        (this.paginationMobileTracks.currentPage - 1);
      if (this.$refs.cardfootermobiletrack) {
        this.$refs.cardfootermobiletrack.froms = from;
      }

      return from;
    },

    totalMobileTracks() {
      if (this.$refs.cardfootermobiletrack) {
        this.$refs.cardfootermobiletrack.totals = this.paginationMobileTracks.total;
      }

      return this.paginationMobileTracks.total;
    },
  };
  //!---Tabla que podria ser usada en un consolidado de N activity x tiempo, actualmente no se esta usando, simplemente se crearon aqui,
  //! se exportan, pero no estan siendo usados en ningun master table, solo el nombre de TableDataMobileMarkings que se utilizo para guardar datos
  //tabla secundaria de las marcaciones del header seleccionado del track movil
  const TableDataMobileMarkings = { ...Tables.Table };
  //columnas de la tabla secundaria de las marcaciones del header seleccionado del track movil
  TableDataMobileMarkings.tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'quantity',
      label: i18n.t('common_words.number_of_records'),
      minWidth: 120,
      sortable: true,
    },
    {
      prop: 'duration_hours',
      label: i18n.t('common_words.duration_in_hours'),
      minWidth: 110,
      sortable: true
    },
    {
      prop: 'duration_minutes',
      label: i18n.t('common_words.duration_in_minutes'),
      minWidth: 110,
      sortable: true
    },
  ];
  // Buscador, paginado y demas de la tabla de los marcaciones del header seleccionado del track de la movil
const SearchMobileMarkings = {
    pagedDataMobileMarkings() {
      return this.TableDataMobileMarkings.slice(this.fromMobileMarkings, this.toMobileMarkings);
    },

    queriedDataMobileMarkings() {
      let result = this.tableDataMobileMarkings;
      if (this.searchQueryMobileMarkings !== '') {
        result = this.fuseSearchMobileMarkings.search(
          '=' + this.searchQueryMobileMarkings + ''
        );
      }
      this.paginationMobileMarkings.total = result.length;

      if (this.$refs.cardfootermobilemarking) {
        this.$refs.cardfootermobilemarking.totals = this.paginationMobileMarkings.total;
      }

      return result.slice(this.fromMobileMarkings, this.toMobileMarkings);
    },

    toMobileMarkings() {
      let highBound = this.fromMobileMarkings + this.paginationMobileMarkings.perPage;
      if (this.totalMobileMarkings < highBound) {
        highBound = this.totalMobileMarkings;
      }

      if (this.$refs.cardfootermobilemarking) {
        this.$refs.cardfootermobilemarking.tos = highBound;
      }

      return highBound;
    },

    fromMobileMarkings() {
      let from =
        this.paginationMobileMarkings.perPage *
        (this.paginationMarkings.currentPage - 1);
      if (this.$refs.cardfootermobilemarking) {
        this.$refs.cardfootermobilemarking.froms = from;
      }

      return from;
    },

    totalMobileMarkings() {
      if (this.$refs.cardfootermobilemarking) {
        this.$refs.cardfootermobilemarking.totals = this.paginationMobileMarkings.total;
      }

      return this.paginationMobileMarkings.total;
    },
  };
  
  return { Table, TableDetails, TableDataMobileTracks, TableDataMobileMarkings,  SearchDetails, SearchMobileTracks, SearchMobileMarkings };
};

export default configTable;
